import GenericDB from './generic-db';

export default class BillingIntentsDB extends GenericDB {
  constructor() {
    super('billingIntents');
  }
}
